import { GridTable } from '@makemydeal/dr-dash-components';

import { PaymentGridBand } from '../../../ScenarioGrid.style';
import { ScenarioRow } from '../../ScenarioRow';

export const PaymentGridRow = () => (
    <ScenarioRow rowKey="paymentGrid">
        <PaymentGridBand data-testid="scenario-payment-grid-band">
            <GridTable />
        </PaymentGridBand>
    </ScenarioRow>
);
